
import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';


const BhpLoadingButton = styled(LoadingButton)({
    backgroundColor: '#e65400',
    color: 'white',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#cc4700'
    }
});

export default BhpLoadingButton;